module.exports = __webpack_public_path__ + "img/tetelu-2.d206b2b0.jpg";